import Vue from 'vue';
import Layout from "../router/layouts/main";
import PageHeader from "@/components/page-header";
import Pagination from "@/components/Pagination";
import DataTableSearch from "@/components/DataTableSearch";
import BaseCard from "@/components/BaseCard";
import Badge from "@/components/widgets/Badge";
import CheckedData from "@/components/widgets/CheckedData";
import loader from "@/components/widgets/loader";
import Hint from "@/components/widgets/Hint";
import NoContent from "@/components/widgets/NoContent";
import Remaining from "../components/Remaining";

export const COMPONENTS = {
    layout: {
        name: 'Layout',
        component: Layout
    },
    pageHeader: {
        name: 'PageHeader',
        component: PageHeader
    },
    pagination: {
        name: 'Pagination',
        component: Pagination
    },
    dataTableSearch: {
        name: 'DataTableSearch',
        component: DataTableSearch
    },
    baseCard: {
        name: 'BaseCard',
        component: BaseCard
    },
    badge: {
        name: 'fBadge',
        component: Badge
    },
    checked: {
        name: 'CheckedData',
        component: CheckedData
    },
    loader: {
        name: 'Loader',
        component: loader
    },
    hint: {
        name: 'Hint',
        component: Hint
    },
    noContent: {
        name: 'NoContent',
        component: NoContent
    },
    remaining: {
        name: 'Remaining',
        component: Remaining
    }
}

export const globalComponents = function () {
    Object.keys(COMPONENTS).forEach(key => {
        Vue.component(COMPONENTS[key].name, COMPONENTS[key].component);
    })
}
